import {z} from '@hono/zod-openapi';

/**
 * Support-only feature: the AI vehicle check used by the support team's training page.
 * Removal is tracked in T20-142687.
 */
export const supportTrainingRequestSchema = z
  .object({
    vin: z
      .string()
      .trim()
      .length(17)
      .regex(/^[A-HJ-NPR-Z0-9]{17}$/i)
      .openapi({example: 'WBA3A5C50CF256789'}),
    mileage: z.number().int().min(0).max(2_000_000).openapi({example: 84_500}),
    note: z.string().trim().max(500).optional().openapi({example: 'Customer reports noise.'}),
  })
  .openapi('SupportTrainingRequest');

export type SupportTrainingRequest = z.infer<typeof supportTrainingRequestSchema>;
